import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'date',
        name: 'date',
        title: 'Tarih',
        format:'YYYY-MM-DD',
        rules: {},
        modal: ['date'],
        data: ['date'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'desc',
        title: 'Açıklama',
        rules: {required: false},
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false
    },

 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/stockMovements.js